import { Outlet} from "react-router"
import { Navigate} from "react-router-dom"

const useAuth = () =>{
    const user =  localStorage.getItem("sub");
    if (user){
        return true
    }else {
        return false
    }
   
};
const ProtecttedRout = (props) =>{

    const auth = useAuth() 
    return auth ? <Outlet/> : <Navigate to ="/" />
    
}
export default ProtecttedRout